import { Spinner } from '@/components/Spinner';
import { ProfileForm } from './form/ProfileForm';
import useGetUserProfile from './hooks/useGetUserProfile';

const ProfileFormContainer = () => {
  const { userData, isLoading } = useGetUserProfile();

  if (isLoading) return <Spinner />;
  return userData ? <ProfileForm userData={userData} /> : null;
};

export default ProfileFormContainer;
